"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/styles/createStyles.js
 ** module id = 803
 ** module chunks = 0
 **/